export function createUploadByteProgress(onChange, intervalMs = 250) {
    const byFile = new Map();
    let sent = 0;
    let delivered = 0;
    let timer = null;
    let lastDeliveryAt = Number.NEGATIVE_INFINITY;
    const deliver = () => {
        timer = null;
        lastDeliveryAt = Date.now();
        if (sent !== delivered) {
            delivered = sent;
            onChange(sent);
        }
    };
    const schedule = () => {
        if (timer !== null)
            return;
        const wait = Math.max(0, lastDeliveryAt + intervalMs - Date.now());
        if (wait === 0)
            deliver();
        else
            timer = setTimeout(deliver, wait);
    };
    const set = (file, bytes) => {
        const clamped = Math.max(0, Math.min(bytes, file.size));
        sent += clamped - (byFile.get(file) ?? 0);
        byFile.set(file, clamped);
        schedule();
    };
    return {
        report: (file, loaded) => set(file, loaded),
        settle: (file) => set(file, file.size),
        get sentBytes() {
            return sent;
        },
        flush() {
            if (timer !== null)
                clearTimeout(timer);
            deliver();
        },
    };
}
